import React, { useState } from "react";
import {
  Paper,
  Box,
  Typography,
  TextField,
  Button,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';

const LoginForm = () => {
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const response = await axios.post("https://oms-be.shreetradingcompany.in/api/token", {
        username: form.username,
        password: form.password,
      });

      if (response.data && response.data.access) {
        localStorage.setItem("token", response.data.access);
        navigate("/");
      } else {
        setError("Invalid response from server.");
      }
    } catch (err) {
      setError("Login failed. Please check your credentials.");
      toast.error("Login failed!! Wrong credentials")
    }
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
        <Toaster />
      <Paper elevation={4} sx={{ p: 4,pt:2, width: 360, borderRadius: 1.5 }}>
        <Typography variant="h5" gutterBottom textAlign="center">
          Login to OMS
        </Typography>
        <Box component="form" onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <TextField
              size="medium"
              label="Username"
              name="username"
              value={form.username}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              size="medium"
              label="Password"
              name="password"
              type="password"
              value={form.password}
              onChange={handleChange}
              fullWidth
            />
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Login
            </Button>
          </Stack>
        </Box>
      </Paper>
    </Box>
  );
};

export default LoginForm;